/* eslint-disable no-multi-spaces */
/* eslint-disable keyword-spacing */
/* eslint-disable space-before-blocks */
/* eslint-disable eqeqeq */
/* eslint-disable space-infix-ops */
/* eslint-disable semi */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */
/* eslint-disable quotes */
/* eslint-disable indent */
/**
 * Implementation based on https://github.com/AzureAD/microsoft-authentication-library-for-js/tree/dev/lib/msal-browser
 */
/* 
* Using certificate credentials with MSAL Node: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-node/docs/certificate-credentials.md
*/

import * as Msal from '@azure/msal-browser'

const envConfig = {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
    tenantId: process.env.VUE_APP_MSAL_TENANT_ID,
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
    logoutUri: process.env.VUE_APP_MSAL_LOGOUT_URI
}

console.log('process.env: ', process.env)
console.log('masl config: ', envConfig)

const msalConfig = {
    auth: {
        clientId: envConfig.clientId,
        authority: 'https://login.microsoftonline.com/' + envConfig.tenantId,
        redirectUri: envConfig.redirectUri,
        postLogoutRedirectUri: envConfig.logoutUri,
        navigateToLoginRequestUrl: false
    },
    system: {
        tokenRenewalOffsetSeconds: 300
    }
};

const loginRequestConfig = {
    scopes: [
        "openid", 
        "profile", 
        "email",
        msalConfig.auth.clientId + "/.default"
    ],
    forceRefresh: true
};

function initMsalInstance() {
    return new Msal.PublicClientApplication(msalConfig);
} 

function initLoginRequest() {
    return loginRequestConfig;
}

export function login() {
    var msalInstance = initMsalInstance();
    var loginRequest = initLoginRequest();

    msalInstance["browserStorage"].clear();
    
    // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/errors.md#using-loginredirect-or-acquiretokenredirect
    msalInstance.handleRedirectPromise().then(res => {
        console.log('login.handleRedirectPromise res: ', res)
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length === 0 || !res) {
            // No user signed in
            msalInstance.loginRedirect(loginRequest);
        }
    }).catch(err => {
        console.log('login.handleRedirectPromise error: ', err)
    })
}

export async function getAccessToken() {
    var msalInstance = initMsalInstance();
    var loginRequest = initLoginRequest();

    return msalInstance.handleRedirectPromise().then(res => {
        console.log('getAccessToken.handleRedirectPromise res: ', res)
        if (!res) {
            console.log('acquireTokenRedirect')
            return msalInstance.acquireTokenRedirect(loginRequest);
        } else {
            var account = msalInstance.getAllAccounts()[0]
            console.log('acquireTokenSilent for account: ', account)
            loginRequest.account = account
            return msalInstance.acquireTokenSilent(loginRequest);
        }
    }).catch(err => {
        console.log('getAccessToken.handleRedirectPromise error: ', err)
    })
}

export function logout() {
    var msalInstance = initMsalInstance();
    msalInstance.handleRedirectPromise().then(res => {
        console.log('logout.handleRedirectPromise res: ', res)
        if (!res) {
            msalInstance.logoutRedirect()
        }
    }).catch(err => {
        console.log('logout.handleRedirectPromise error: ', err)
    })    
}

export function acquireTokenSilent() {
    var msalInstance = initMsalInstance('ups');
    return msalInstance.acquireTokenSilent({
        scopes: [
            "openid", 
            "profile", 
            "email",
            msalConfig.auth.clientId + "/.default"
        ],
        // forceRefresh: true
        account: msalInstance.getAllAccounts()[0]
    });
}
